<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="pvii"></a>
<h1 class="toc-title"><span><em>Contents</em></span></h1>
<p class="toc-chapter" id="toc-copyright"><span><span href="#/copyright" title="Link target outside of Sample">Copyright</span></span></p>
<p class="toc-chapter" id="toc-acknowledgements"><span><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></span></p>
<p class="toc-chapter1" id="toc-chapter000"><span><a href="#/chapter000">Withnail and I</a></span></p>
<p class="toc-chapter" id="toc-chapter001"><span><span href="#/chapter001" title="Link target outside of Sample">Warlock</span></span></p>
<p class="toc-chapter" id="toc-chapter002"><span><span href="#/chapter002" title="Link target outside of Sample">Henry and June</span></span></p>
<p class="toc-chapter" id="toc-chapter003"><span><span href="#/chapter003" title="Link target outside of Sample">LA Stories</span></span></p>
<p class="toc-chapter" id="toc-chapter004"><span><span href="#/chapter004" title="Link target outside of Sample">Hudson Hawk</span></span></p>
<p class="toc-chapter" id="toc-chapter005"><span><span href="#/chapter005" title="Link target outside of Sample">More LA Stories</span></span></p>
<p class="toc-chapter" id="toc-chapter006"><span><span href="#/chapter006" title="Link target outside of Sample">The Player</span></span></p>
<p class="toc-chapter" id="toc-chapter007"><span><span href="#/chapter007" title="Link target outside of Sample">Dracula</span></span></p>
<p class="toc-chapter" id="toc-chapter008"><span><span href="#/chapter008" title="Link target outside of Sample">The Age of Innocence</span></span></p>
<p class="toc-chapter" id="toc-chapter009"><span><span href="#/chapter009" title="Link target outside of Sample">Pret à Porter</span></span></p>
<p class="toc-chapter1" id="toc-epilogue"><span><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></span></p>
<p class="toc-chapter" id="toc-afterword"><span><span href="#/afterword" title="Link target outside of Sample">Afterword: Budget/No Budget</span></span></p>
<a id="pviii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?b6dc8bf6